export interface IProduct {
  name: string;
  description: string;
  productTypeOptions:string;
  productType: string;
  productCategory: string;
  homeUrl: string;
  imageUrl: string;
  statementDescriptor: string;
  productUrl: string;
  deleted?: boolean
}

type Interval = 'day' | 'week' | 'month' | 'year'

interface IRecurring {
  interval: Interval
  intervalCount?: number
}

export interface IPrice  {
  name: string
  type: string
  product: string
  currency: string
  amount: number
  priceDescription: string
  trialPeriod: number
  membershipOfferId: string
  intervalCount: number
  interval:string
  totalCycles:number
  setupFee: number
}

export enum ProductType {
  ONE_TIME = 'one_time',
  RECURRING = 'recurring'
}

export const billingCycles = [
  {
    label: 'Daily',
    value: 'day',
  },
  {
    label: 'Weekly',
    value: 'week',
  },
  {
    label: 'Monthly',
    value: 'month',
  },
  {
    label: 'Year',
    value: 'year',
  },
]

export const billingCyclesForCustom = [
  {
    label: 'Days',
    value: 'day',
  },
  {
    label: 'Weeks',
    value: 'week',
  },
  {
    label: 'Months',
    value: 'month',
  },
]